import 'prometheus.aaa.scss';
import 'prometheus.modern.scss';

import './theme.aaa.scss';
import './theme.modern.scss';

import { registerDocumentClickBubblingOnTop } from '@itslearning/atlas/frames/IframeClickEventHelper';

import App from './lib/App/App.svelte';
import config from './config';

registerDocumentClickBubblingOnTop();

const app = new App({
    target: document.getElementById('enrollment-person-data-submission'),
    props: config
});

export default app;
